<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Добавление и&nbsp;редактирование записи</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="kak-popast"
            class="typography__headline2"
          >
            Как попасть
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>Давайте добавим запись в&nbsp;ваш проект.</p>

            <p>В&nbsp;меню слева перейдите в&nbsp;раздел &laquo;Журнал записей&raquo;.</p>

            <p>
              Добавить запись можно двумя способами&nbsp;&mdash; по&nbsp;кнопке &laquo;Добавить запись&raquo; или выбрав
              нужную ячейку в&nbsp;расписании, в&nbsp;этом случае на&nbsp;странице добавления записи уже предвыберется
              нужный мастер и&nbsp;время начала записи.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="personalnaya-zapis"
            class="typography__headline2"
          >
            Персональная запись
          </FaqArticlesBlockHeading>

          <h3 class="typography__headline4">Основная информация</h3>

          <div class="block-small">
            <p>
              У&nbsp;записей есть три типа: персональная (на&nbsp;одного), групповая (на&nbsp;несколько человек)
              и&nbsp;перерыв (техническая внутренняя запись).
            </p>

            <p>Персональная запись предоставляется только одному клиенту.</p>

            <p>
              Статус по-умолчанию выбран &laquo;В&nbsp;ожидании&raquo;. Если запись будущая, то&nbsp;можно его
              не&nbsp;трогать. Если запись уже прошла или была отменена&nbsp;&mdash; выберите соответствующий статус.
              Позже статус также можно будет сменить.
            </p>

            <p>
              Также можно добавить комментарий к&nbsp;записи, который будет виден только вам и&nbsp;вашим
              администраторам в&nbsp;CRM.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-2.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <h3 class="typography__headline4">Клиент</h3>

          <div class="block-small">
            <p>В&nbsp;персональной записи можно добавить только одного клиента.</p>

            <p>Выберите из&nbsp;списка нужного клиента.</p>

            <p>
              Статусы посещения и&nbsp;оплаты по-умолчанию выбраны для новой, будущей записи. Если запись уже прошла,
              была отменена или оплачена&nbsp;&mdash; выберите соответствующие статусы. Позже статусы также можно будет
              сменить.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-3.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-4.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              Если хотите добавить запись на&nbsp;нового, еще не&nbsp;зарегистрированного клиента&nbsp;&mdash; его также
              можно быстро добавить отсюда.
            </p>

            <p>
              Начните набирать в&nbsp;поле имя клиента и&nbsp;нажмите внизу списка на&nbsp;вариант с&nbsp;кнопкой
              &laquo;Создать&raquo;.
            </p>

            <p>Не&nbsp;забудьте после попросить клиента <BaseLink
              target="_blank"
              to="/faq/articles/dobavleniye-i-redaktirovaniye-klienta"
            >заполнить все его данные</BaseLink> или сделать это самому.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-5.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>В&nbsp;появившемся окне заполните все обязательные поля и&nbsp;нажмите &laquo;Добавить&raquo;.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-6.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <h3 class="typography__headline4">Услуги</h3>

          <p>Нажмите &laquo;Выбрать услуги&raquo;.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-7.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            В&nbsp;появившемся окне выберите услуги, необходимые для добавляемой записи и&nbsp;нажмите
            &laquo;Готово&raquo;.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-8.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            После выбора услуг, вы&nbsp;увидите их&nbsp;с&nbsp;возможностью быстро удалить по&nbsp;крестику
            из&nbsp;списка ненужные.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-9.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <h3 class="typography__headline4">Детали</h3>

          <div class="block-small">
            <p>
              Если вы&nbsp;добавляете запись по&nbsp;кнопке &laquo;Добавить запись&raquo; и&nbsp;не&nbsp;заполняли
              информацию в&nbsp;предыдущих блоках&nbsp;&mdash; все данные будут пустые. Если нажали добавление записи
              в&nbsp;ячейке расписания&nbsp;&mdash; предзаполнятся дата и&nbsp;время.
            </p>

            <p>
              Если услуги были выбраны, то&nbsp;длительность и&nbsp;стоимость также заполнятся, исходя из&nbsp;данных
              этих услуг.
            </p>

            <p>
              В&nbsp;расчетной стоимости указывается общая стоимость всех услуг. В&nbsp;итоговой стоимости можно
              уменьшить или увеличить стоимость всей записи.
            </p>

            <p>После заполнения всех данных внимательно проверьте&nbsp;их.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-10.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-11.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <h3 class="typography__headline4">Сотрудники и добавление записи</h3>

          <p>Нажмите &laquo;Выбрать сотрудников&raquo;.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-12.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            В&nbsp;появившемся окне выберите сотрудников, необходимых для этой записи и&nbsp;нажмите
            &laquo;Готово&raquo;.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-13.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              После выбора сотрудников, вы&nbsp;увидите их&nbsp;с&nbsp;возможностью быстро удалить по&nbsp;крестику
              из&nbsp;списка ненужные.
            </p>

            <p>
              Как заполните все данные записи, нажмите &laquo;Сохранить&raquo; в&nbsp;самом низу страницы. После
              успешного добавления увидите в&nbsp;правом верхнем углу уведомление.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-14.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="gruppovaya-zapis"
            class="typography__headline2"
          >
            Групповая запись
          </FaqArticlesBlockHeading>

          <h3 class="typography__headline4">Основная информация</h3>

          <div class="block-small">
            <p>
              У&nbsp;записей есть три типа: персональная (на&nbsp;одного), групповая (на&nbsp;несколько человек)
              и&nbsp;перерыв (техническая внутренняя запись).
            </p>

            <p>Групповая запись предоставляется нужному количеству клиентов.</p>

            <p>
              Статус по-умолчанию выбран &laquo;В&nbsp;ожидании&raquo;. Если запись будущая, то&nbsp;можно его
              не&nbsp;трогать. Если запись уже прошла или была отменена&nbsp;&mdash; выберите соответствующий статус.
              Позже статус также можно будет сменить.
            </p>

            <p>Количество участников обязательно для заполнения.</p>

            <p>
              Также можно добавить комментарий к&nbsp;записи, который будет виден только вам и&nbsp;вашим
              администраторам в&nbsp;CRM.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-15.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <h3 class="typography__headline4">Клиент</h3>

          <div class="block-small">
            <p>В&nbsp;групповой записи можно добавить нужное количество клиентов.</p>

            <p>Нажмите &laquo;Добавить клиента&raquo; и&nbsp;выберите из&nbsp;списка нужного.</p>

            <p>
              Статусы посещения и&nbsp;оплаты по-умолчанию выбраны новой, будущей записи. Если запись уже прошла, была
              отменена или оплачена&nbsp;&mdash; выберите соответствующие статусы. Позже статусы также можно будет
              сменить.
            </p>

            <p>Если нужно добавить еще одного&nbsp;&mdash; снова нажмите &laquo;Добавить клиента&raquo;.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-16.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-17.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <h3 class="typography__headline4">Услуги</h3>

          <p>Нажмите &laquo;Выбрать услуги&raquo;.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-18.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            В&nbsp;появившемся окне выберите услуги, необходимые для добавляемой записи и&nbsp;нажмите
            &laquo;Готово&raquo;.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-19.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            После выбора услуг, вы&nbsp;увидите их&nbsp;с&nbsp;возможностью быстро удалить по&nbsp;крестику
            из&nbsp;списка ненужные.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-20.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <h3 class="typography__headline4">Детали</h3>

          <div class="block-small">
            <p>
              Если вы&nbsp;добавляете запись по&nbsp;кнопке &laquo;Добавить запись&raquo; и&nbsp;не&nbsp;заполняли
              информацию в&nbsp;предыдущих блоках&nbsp;&mdash; все данные будут пустые. Если нажали добавление записи
              в&nbsp;ячейке расписания&nbsp;&mdash; предзаполнятся дата и&nbsp;время.
            </p>

            <p>
              Если услуги были выбраны, то&nbsp;длительность и&nbsp;стоимость также заполнятся, исходя из&nbsp;данных
              этих услуг.
            </p>

            <p>
              В&nbsp;расчетной стоимости указывается общая стоимость всех услуг. В&nbsp;итоговой стоимости можно
              уменьшить или увеличить стоимость всей записи.
            </p>

            <p>После заполнения всех данных внимательно проверьте&nbsp;их.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-21.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-22.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <h3 class="typography__headline4">Сотрудники и добавление записи</h3>

          <p>Нажмите &laquo;Выбрать сотрудников&raquo;.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-23.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            В&nbsp;появившемся окне выберите сотрудников, необходимых для этой записи и&nbsp;нажмите
            &laquo;Готово&raquo;.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-24.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              После выбора сотрудников, вы&nbsp;увидите их&nbsp;с&nbsp;возможностью быстро удалить по&nbsp;крестику
              из&nbsp;списка ненужные.
            </p>

            <p>
              Как заполните все данные записи, нажмите &laquo;Сохранить&raquo; в&nbsp;самом низу страницы. После
              успешного добавления увидите в&nbsp;правом верхнем углу уведомление.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-25.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="zapis-pereryv"
            class="typography__headline2"
          >
            Запись-перерыв
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              У&nbsp;записей есть три типа: персональная (на&nbsp;одного), групповая (на&nbsp;несколько человек)
              и&nbsp;перерыв (техническая внутренняя запись).
            </p>

            <p>
              Перерыв был создан для быстрого и&nbsp;точечного добавления перерыва нужному сотруднику, минуя расписание.
            </p>

            <p>Выберите нужного сотрудника, время перерыва и&nbsp;его длительность.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-26.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            Как заполните все данные записи, нажмите &laquo;Сохранить&raquo; в&nbsp;самом низу страницы. После успешного
            добавления увидите в&nbsp;правом верхнем углу уведомление.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-27.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="redaktirovaniye-zapisi"
            class="typography__headline2"
          >
            Редактирование записи
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              После добавления записи, вы&nbsp;сможете найти её&nbsp;в&nbsp;<BaseLink
              target="_blank"
                to="/faq/articles/zhurnal-zapisej-i-ikh-dannye"
                >журнале записей</BaseLink
              >.
            </p>

            <p>Нужно открыть страницу записи, нажав по&nbsp;ней в&nbsp;расписании.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-28.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>Отсюда можно перейти к&nbsp;редактированию по&nbsp;кнопке сверху.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/dobavlenie-i-redaktirovanie-zapisi-29.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            С&nbsp;добавлением записи разобрались. Самое время перейти к&nbsp;изучению
            <BaseLink to="/faq/articles/zhurnal-zapisej-i-ikh-dannye"
              >журнала записей и&nbsp;просмотра их&nbsp;данных</BaseLink
            >.
          </p>
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Онлайн-&#65279;запись",
    url: "/faq/categories/onlayn-zapis",
  },
  {
    name: "Добавление и&nbsp;редактирование записи",
  },
];

const menu = [
  {
    name: "Как&nbsp;попасть",
    url: "kak-popast",
  },
  {
    name: "Персональная запись",
    url: "personalnaya-zapis",
  },
  {
    name: "Групповая&nbsp;запись",
    url: "gruppovaya-zapis",
  },
  {
    name: "Запись-перерыв",
    url: "zapis-pereryv",
  },
  {
    name: "Редактирование&nbsp;записи",
    url: "redaktirovaniye-zapisi",
  },
];

const relatedArticles = [
  {
    name: "Настройки записей",
    slug: "nastroyki-zapisey",
  },
  {
    name: "Категории услуг",
    slug: "kategorii-uslug",
  },
  {
    name: "Добавление и&nbsp;редактирование услуги",
    slug: "dobavleniye-i-redaktirovaniye-uslugi",
  },
  {
    name: "Список услуг и&nbsp;их данные",
    slug: "spisok-uslug-i-ikh-dannye",
  },
];

useSeoMeta({
  title: "Добавление и редактирование записи",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

p a {
  display: contents;
}
</style>
